import { render, staticRenderFns } from "./BatchView.vue?vue&type=template&id=9a672bb4&"
import script from "./BatchView.vue?vue&type=script&lang=js&"
export * from "./BatchView.vue?vue&type=script&lang=js&"
import style0 from "./BatchView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports